/**
 * Firebase startup patch
 * 
 * This file contains critical initialization code that ensures Firebase data loading works properly.
 * It sets important local storage flags to enable compatibility modes and proper data sync.
 */
import logger from './logger';

/**
 * Applies critical startup patches to fix common Firebase data issues
 */
export function applyFirebaseStartupPatch() {
  logger.info('Applying Firebase startup patch...');
  
  try {
    // Critical flags for proper Firebase data loading
    localStorage.setItem('useCurrentDates', 'true');
    localStorage.setItem('disableSampleData', 'false');
    
    // If we're having issues, use real Firebase (this may help data sync)
    localStorage.setItem('USE_REAL_FIREBASE', 'true');
    
    // Clean up any conflicting flags
    localStorage.removeItem('FORCE_DEV_MODE');
    
    // Make sure firebase persistence is enabled
    localStorage.setItem('FIREBASE_PERSISTENCE_ENABLED', 'true');
    
    // Set a flag that we've applied the patch
    const now = new Date().toISOString();
    localStorage.setItem('FIREBASE_PATCH_APPLIED', now);
    
    logger.info('Firebase startup patch applied successfully at', now);
    return true;
  } catch (error) {
    logger.error('Error applying Firebase startup patch:', error);
    return false;
  }
}

// Automatically run the patch when this file is imported
applyFirebaseStartupPatch();